<template>
  <div class="w-100">
    <SectionTitle :text="title" class="mb-3" />
    <template v-if="content != null && content.length > 0">
      <p v-for="(sphere, index) in content" :key="index" class="top-item">
        <span class="top-item__percent"> {{ formatNumber(sphere?.value, 1, ' ', ',', true) }}% </span>
        {{ sphere?.key }}
      </p>
    </template>
    <p class="mt-24 mb-24" v-else>{{ emptyMessage }}</p>
  </div>
</template>

<script>
  import SectionTitle from '@/common/components/redesigned/SectionTitle/SectionTitle.vue';
  import textMixin from '@/common/mixins/text';

  import { DATA_EMPTY_MESSAGE } from '../../utils/constants';

  export default {
    name: 'TopCountryStatistic',
    components: { SectionTitle },
    mixins: [textMixin],
    props: {
      title: {
        type: String,
        default: '',
      },
      content: {
        type: Array,
        default: () => [],
      },
    },
    data: () => ({
      emptyMessage: DATA_EMPTY_MESSAGE,
    }),
  };
</script>

<style lang="scss" scoped>
  .top-item {
    display: inline-block;
    padding: 10px;
    border: 1px solid #d6e4ec;
    border-radius: 4px;
    font: $fira-12;
    margin: 0 10px 10px 0;
    &__percent {
      font-weight: 700;
      color: $green;
    }
  }
</style>
